import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable()
export class StorageProvider {
  constructor(public storage: Storage) {}

  set(key: string, value: any) {
    return this.storage.set(key, value);
  }

  get(key: string) {
    return this.storage.get(key);
  }

  remove(key: string) {
    return this.storage.remove(key);
  }
}



// WEBPACK FOOTER //
// ./src/providers/storage/storage.ts